import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import { UserTransactionsDetailsComp } from "../../../components/userProfileComp/UserTransactionsDetailsWrapperComp";

export const UserTransactionsDetailsPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="title"
          title="Transactions Details"
          showNotification
        ></TopBar>
        <UserTransactionsDetailsComp></UserTransactionsDetailsComp>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserTransactionsDetailsPage;
